module.exports = __webpack_public_path__ + "img/图标3.aab8c359.png";